import {Grid, Alert} from "@mui/material";
import { SeccionWRMDatosOperacion, SeccionWRMInstrumento } from "./components";
import { EntityWithIdFields, QueryStatus } from "src/types";
import { HttpWRM, OperacionWRM } from "./api";
import { useOperacionWRM } from "./hooks";
import { zodResolver } from "@hookform/resolvers/zod";
import { SubmitHandler, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useContext, useEffect } from "react";
import { useLoader } from "src/hooks/useLoader";
import { ContextOperacion, ContextOperacionType } from "../../RefactorLayout";
import { FormOperacionWRM, schemaOperacionWRM } from "./types/types";
import { SeccionFirmas } from "../../components/SeccionFirmas";
import {SistemaTipo} from "../../../../types/enum/enum";


type SistemaWRMercadoContentProps = {
    operacion: OperacionWRM,
}

const SistemaWRMercadoContent = ({ operacion }: SistemaWRMercadoContentProps) => {

    const { setSavePromise, codSistemaTipo: codSistema } = useContext<ContextOperacionType>(ContextOperacion)

    const formMethods = useForm<FormOperacionWRM>({
        resolver: zodResolver(schemaOperacionWRM),
        values: { ...operacion }
    })

    const { showLoader, hideLoader } = useLoader()

    useEffect(() => {
        if (operacion.permiteEditarOperacion) {
            const handleSave: SubmitHandler<FormOperacionWRM> = (data) => {
                showLoader()
                const promise = HttpWRM.put(operacion.id, data)

                toast.promise(promise, {
                    loading: 'Guardando.',
                    success: 'Guardado correctamente.',
                    error: e => `${e}`
                }).finally(hideLoader)
            }

            const onSave = () => formMethods.handleSubmit(handleSave)
            setSavePromise(onSave)
        }
    }, [])

    return (
        <>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <SeccionWRMDatosOperacion
                        formMethods={formMethods}
                        readOnly={!operacion.permiteEditarOperacion}
                        operacion={operacion}
                        codSistemaPrincipal={operacion.codPais}
                        codSistema={codSistema}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SeccionWRMInstrumento
                        idOperacion={operacion[EntityWithIdFields.Id]}
                        permiteEditar={operacion.permiteEditarOperacion}
                        permiteEliminar={operacion.permiteEliminarOperacion}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SeccionFirmas
                        codSistema={SistemaTipo.MinutaMercado}
                        idOperacion={operacion[EntityWithIdFields.Id]}
                    />
                </Grid>
            </Grid>
        </>
    )
}


const SistemaWRMercado = () => {

    const { idOperacion, setSavePromise } = useContext<ContextOperacionType>(ContextOperacion)

    const { status, operacion } = useOperacionWRM(idOperacion)

    const { showLoader, hideLoader } = useLoader()

    useEffect(() => {
        if (status === QueryStatus.Loading) {
            showLoader()
        } else {
            hideLoader();
        }
    }, [status])

    if (!operacion) {
        return (
            <></>
        )
    }

    if (status === QueryStatus.Error) {
        return (
            <Alert severity='error'>
                Se produjo un error al cargar la operación.
            </Alert>
        )
    }

    return (
        <SistemaWRMercadoContent
            operacion={operacion}
        />
    )
}

export default SistemaWRMercado;
